import { supabase } from '../lib/supabase'

export type RoadmapGroup = {
  id: string
  name: string
  color?: string | null
  order_index: number
}

export type RoadmapLabel = {
  id: string
  name: string
  color?: string | null
}

export type RoadmapItemStakeholder = {
  user_id: string
  role: 'owner' | 'stakeholder' | 'approver'
}

export type RoadmapItem = {
  id: string
  title: string
  description?: string | null
  group_id?: string | null
  status: 'ideia' | 'planejado' | 'em_andamento' | 'concluido' | 'bloqueado'
  start_date?: string | null
  end_date?: string | null
  priority?: number | null
  effort?: number | null
  label_ids?: string[]
  stakeholders?: RoadmapItemStakeholder[]
}

export const projetosService = {
  async getGroups(): Promise<RoadmapGroup[]> {
    const { data, error } = await supabase.from('roadmap_groups').select('*').order('order_index', { ascending: true })
    if (error) throw error
    return (data || []) as any
  },
  async getLabels(): Promise<RoadmapLabel[]> {
    const { data, error } = await supabase.from('roadmap_labels').select('*').order('name', { ascending: true })
    if (error) throw error
    return (data || []) as any
  },
  async searchItems(params: {
    q?: string
    from?: string | null
    to?: string | null
    group_id?: string | null
    status?: string | null
    me?: boolean
  }): Promise<RoadmapItem[]> {
    const { data, error } = await supabase.rpc('rpc_search_roadmap_items', {
      p_q: params.q || null,
      p_from: params.from || null,
      p_to: params.to || null,
      p_group: params.group_id || null,
      p_status: params.status || null,
      p_me: !!params.me
    })
    if (error) throw error
    return (data || []) as any
  },
  async upsertItem(item: Partial<RoadmapItem>): Promise<string> {
    const { data, error } = await supabase.rpc('rpc_upsert_roadmap_item', {
      p_item: item as any
    })
    if (error) throw error
    return data as string
  }
}


